import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const PhoneVideoContainer = styled.div`
  max-width: 280px;
  position: relative;
  justify-self: center;
  grid-area: home-phone;
  grid-column: 2 / 4;
  grid-row: 1 / 2;
  margin-left: 0.8rem;
  margin-bottom: 1.2rem;
  filter: drop-shadow(5.2px 44.2px 42.1px rgba(0, 39, 74, 0.3));

  @media all and (max-width: ${layout.subMd}) {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
    margin-top: 3rem;
    margin-bottom: 1.8rem;
  }
  @media all and (max-width: ${layout.xs}) {
    max-width: 65%;
  }
`

export const PhoneVideoPosition = styled.div`
  max-width: 90%;
  position: absolute;
  bottom: 2%;
  right: 5%;
  margin: 0 auto;

  & > .gatsby-image-wrapper {
    position: relative;
    z-index: 2;
  }

  & > video {
    position: absolute;
    z-index: 2;
    left: 0px;
    top: 0px;
  }
`;
